import { useStore } from '../store';

export const useUpdateComponentState = () => {
  const { updateParagraphState, getParagraphState } = useStore();
  return (
    p_course: string,
    p_topic: string,
    id: string,
    componentId: string
  ) => {
    const paragraphState = getParagraphState(p_course, p_topic).find(
      (itm) => itm.id === id
    );
    const components =
      paragraphState?.components?.filter((itm) => itm !== componentId) || [];
    const state = components.length
      ? paragraphState
        ? paragraphState.state
        : 'not-start'
      : 'completed';
    updateParagraphState(p_course, p_topic, id, state, components);
  };
};
